export enum ReasonCategoryEnum{
    GENERAL = 'GENERAL',
    ENQUIRY_REJECT_REASON = 'ENQUIRY REJECT REASON'
}